<template>
  <div class="card">
    <h3>Transactions</h3>
    <div class="table-wrap compact-table-wrapper">
      <table class="compact-table">
        <caption class="sr-only">Transactions table showing recent deals</caption>
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Type</th>
            <th scope="col">Value</th>
            <th scope="col">Target</th>
            <th scope="col">Buyer</th>
            <th scope="col">Raised</th>
            <th scope="col">Pre-Money</th>
            <th scope="col">Post-Money</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(t,i) in items" :key="i">
            <td>{{ formatDate(t.announceDate) }}</td>
            <td>{{ t.transactionType || '-' }}</td>
            <td class="num">{{ formatNumber(t.transactionValue) }}</td>
            <td v-html="boldTarget(t.targetName)"></td>
            <td v-html="t.buyerName == 'Data Unavailable' ? '-' : boldBuyer(t.buyerName)"></td>
            <td class="num">{{ formatNumber(t.raised) }}</td>
            <td class="num">{{ formatNumber(t.preMoney) }}</td>
            <td class="num">{{ formatNumber(t.postMoney) }}</td>
            <td>{{ t.status || '-' }}</td>
          </tr>
          <tr v-if="items.length===0"><td colspan="9" class="empty">No transactions</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Transactions',
  props: { items: { type: Array, default: () => [] }, companyName: { type: String, default: '' } },
  methods: {
    formatNumber(v) { return (v || v===0) ? Number(v).toLocaleString() : '-' },
    formatDate(d) { return (d && d.format) ? d.format('DD-MMM-YYYY') : (d || '-') },
    // Safe bolding that escapes regex metacharacters
    boldString(str, substr){
      if (!str) return '-';
      if (!substr) return str;
      try{
        const esc = substr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const re = new RegExp(esc, 'g');
        return String(str).replace(re, function(m){ return '<b>' + m + '</b>'; });
      }catch(e){ return str }
    },
    boldTarget(name){ return this.boldString(name || '-', this.companyName) },
    boldBuyer(name){ return this.boldString(name || '-', this.companyName) }
  },
};
</script>

<style scoped>
.card{ padding: var(--mobile-card-padding); border-bottom: 1px solid var(--compact-table-border) }
.table-wrap{ overflow-x:auto }
table{ width:100%; border-collapse:collapse; min-width:0; table-layout:auto }
th,td{ border:0; padding:var(--compact-table-cell-padding); font-size:var(--compact-table-font-size) }
td.num{ text-align:right }
.empty{ color:#777; padding:6px 0; text-align:center }
tbody tr{ border-bottom:1px solid var(--compact-table-border) }
tbody tr:nth-child(odd){ background:var(--compact-table-zebra) }
</style>
